export enum PlannedActivityUserTripStatus {
  NotConfirmed,
  ConfirmedOnBoard,
  SignedOff,
}
